import { CSSProperties } from '@material-ui/core/styles/withStyles';
import React from 'react';
interface IProps {
  color?: string;
  width?: number;
  height?: number;
  style?: CSSProperties;
}

const TextstoryIcon = ({ color, width = 14, height = 12, style }: IProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox={`0 0 14 12`}
    preserveAspectRatio={width !== 14 && height !== 12 ? 'none' : 'xMidYMid meet'}
  >
    <path
      fill={color || '#000'}
      fillRule="nonzero"
      d="M1.2 4h4.6c.11 0 .2.09.2.2v.6a.2.2 0 0 1-.2.2H1.2a.2.2 0 0 1-.2-.2v-.6c0-.11.09-.2.2-.2zm.675-4C.812 0 0 .78 0 1.8v9c0 .66.563 1.2 1.25 1.2H7.5V2.4H1.875c-.375 0-.625-.24-.625-.6s.25-.6.625-.6H8.75v9.6H10V0H1.875z"
    />
  </svg>
);

export default TextstoryIcon;
